// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.skip-content {
	position: absolute;
	top: -100px;
	left: 0;
	color: #F7E987;
	background-color: #445069;
	padding: 15px;
	font-size: 15px;
	z-index: 100;
	text-decoration: none;
}

.skip-content:focus {
	top: 80px;
}`, "",{"version":3,"sources":["webpack://./src/styles/skipcontent.css"],"names":[],"mappings":"AAAA;CACC,kBAAkB;CAClB,WAAW;CACX,OAAO;CACP,cAAc;CACd,yBAAyB;CACzB,aAAa;CACb,eAAe;CACf,YAAY;CACZ,qBAAqB;AACtB;;AAEA;CACC,SAAS;AACV","sourcesContent":[".skip-content {\n\tposition: absolute;\n\ttop: -100px;\n\tleft: 0;\n\tcolor: #F7E987;\n\tbackground-color: #445069;\n\tpadding: 15px;\n\tfont-size: 15px;\n\tz-index: 100;\n\ttext-decoration: none;\n}\n\n.skip-content:focus {\n\ttop: 80px;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
